// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MIusVBcKZpyshWXBJktE{padding-left:12px;gap:5px}.Vm82dv9g2L0K6Slacs64 input{flex:0 0 auto}`, "",{"version":3,"sources":["webpack://./src/shared/ui/TextFieldWithFixedText/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,OAAA,CAGA,4BACE,aAAA","sourcesContent":[".label {\n  padding-left: 12px;\n  gap: 5px;\n}\n.collapsed {\n  input {\n    flex: 0 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `MIusVBcKZpyshWXBJktE`,
	"collapsed": `Vm82dv9g2L0K6Slacs64`
};
export default ___CSS_LOADER_EXPORT___;
